import { render } from "./PasswordForgotten.vue?vue&type=template&id=6e13f267&scoped=true"
import script from "./PasswordForgotten.vue?vue&type=script&lang=js"
export * from "./PasswordForgotten.vue?vue&type=script&lang=js"

import "./PasswordForgotten.vue?vue&type=style&index=0&id=6e13f267&scoped=true&lang=css"

import exportComponent from "/srv/guestwaiterreportingfront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e13f267"]])

export default __exports__